export const thousandSeparator = (num: string | number | undefined) => {
	if (num === undefined || num === null) {
		return "";
	}
	var formatter = new Intl.NumberFormat("id-ID", {
		maximumFractionDigits: 0,
		minimumFractionDigits: 0,
	});
	return formatter.format(Number(num));
};
